import { useTranslation } from 'react-i18next';
import { InputProjectSimulator, MaterialsToComplete } from '../../ProjectSimulator';
import { MaterialSynthese } from '../../../../projects/EquipmentList/AddEquipment/ModelingEquipment/CarbonEstimation/CarbonEstimation';
import { Checkbox } from '@material-ui/core';
import { Controller, UseFormReturn } from 'react-hook-form';
import { BuildingStructureData } from '../BuildingStructure';
import { projectSimulatorFieldRules } from '../../utils';

type BuildingStructureLastPartProps = {
  buildingStructure: BuildingStructureData;
  wallTypeMaterials: MaterialsToComplete[];
  ceilingMaterials: MaterialsToComplete[];
  floorMaterials: MaterialsToComplete[];
  form: UseFormReturn;
};

function BuildingStructureLastPart({
  buildingStructure,
  wallTypeMaterials,
  ceilingMaterials,
  floorMaterials,
  form,
}: BuildingStructureLastPartProps) {
  const { t } = useTranslation();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: '4px',
        width: '50%',
      }}
    >
      <label className="form-label" style={{ paddingLeft: '24px' }}>
        {t('APP.PROJECT.SIMULATOR.ADVANCED_CONCEPTION.FORM.LABEL.WALLTYPE', {
          defaultValue: 'Cloison',
        })}
      </label>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          rowGap: '6px',
        }}
      >
        <div
          style={{
            display: 'flex',
            columnGap: '10px',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              rowGap: '4px',
            }}
          >
            <InputProjectSimulator
              form={form}
              name="separativeWall"
              defaultValue={buildingStructure.wallType.separative}
              rules={projectSimulatorFieldRules.percentage}
              isPercentageField={true}
              style={{ width: '67px' }}
            />

            <label className="form-field--label">
              {t(
                'APP.PROJECT.SIMULATOR.ADVANCED_CONCEPTION.FORM.FIELD.LABEL.SEPARATIVE',
                { defaultValue: 'Séparative' }
              )}
            </label>
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              rowGap: '4px',
            }}
          >
            <InputProjectSimulator
              form={form}
              name="distributiveWall"
              defaultValue={buildingStructure.wallType.distributive}
              rules={projectSimulatorFieldRules.percentage}
              isPercentageField={true}
              style={{ width: '67px' }}
            />
            <label className="form-field--label">
              {t(
                'APP.PROJECT.SIMULATOR.ADVANCED_CONCEPTION.FORM.FIELD.LABEL.DISTRIBUTIVE',
                { defaultValue: 'Distributive' }
              )}
            </label>
          </div>
        </div>
        <MaterialSynthese lines={wallTypeMaterials} />
      </div>

      <label
        className="form-label"
        style={{
          marginTop: '12px',
          paddingLeft: '24px',
        }}
      >
        {t('APP.PROJECT.SIMULATOR.ADVANCED_CONCEPTION.FORM.LABEL.CEILING', {
          defaultValue: 'Plafond',
        })}
      </label>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          rowGap: '6px',
        }}
      >
        <div
          style={{
            display: 'flex',
            columnGap: '10px',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              rowGap: '4px',
            }}
          >
            <InputProjectSimulator
              form={form}
              name="fixedCeiling"
              defaultValue={buildingStructure.ceiling.fixed}
              rules={projectSimulatorFieldRules.percentage}
              isPercentageField={true}
              style={{ width: '67px' }}
            />
            <label className="form-field--label">
              {t(
                'APP.PROJECT.SIMULATOR.ADVANCED_CONCEPTION.FORM.FIELD.LABEL.FIXED_CEILING',
                {
                  defaultValue: 'Fixe',
                }
              )}
            </label>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              rowGap: '4px',
            }}
          >
            <InputProjectSimulator
              form={form}
              name="removableCeiling"
              defaultValue={buildingStructure.ceiling.removable}
              rules={projectSimulatorFieldRules.percentage}
              isPercentageField={true}
              style={{ width: '67px' }}
            />
            <label className="form-field--label">
              {t(
                'APP.PROJECT.SIMULATOR.ADVANCED_CONCEPTION.FORM.FIELD.LABEL.REMOVABLE_CEILING',
                {
                  defaultValue: 'Démontable',
                }
              )}
            </label>
          </div>
        </div>

        <MaterialSynthese lines={ceilingMaterials} />
      </div>

      <Controller
        control={form.control}
        name="fakeFloor"
        defaultValue={buildingStructure.floor.fake}
        render={({ field }) => (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginTop: '12px',
              paddingLeft: '24px',
            }}
          >
            <label className="form-label" style={{ paddingLeft: '3px' }}>
              {t('APP.PROJECT.SIMULATOR.ADVANCED_CONCEPTION.FORM.LABEL.FLOOR', {
                defaultValue: 'Sol',
              })}
            </label>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                columnGap: '4px',
              }}
            >
              <Checkbox
                {...field}
                color="primary"
                style={{ width: '24px', height: '24px' }}
                checked={field.value ?? buildingStructure.floor.fake}
                value={field.value ?? buildingStructure.floor.fake}
              />
              <label className="form-label" style={{ marginBottom: 0 }}>
                {t(
                  'APP.PROJECT.SIMULATOR.ADVANCED_CONCEPTION.CHECKBOX.LABEL.FAKE_FLOOR',
                  {
                    defaultValue: 'Présence de faux plancher',
                  }
                )}
              </label>
            </div>
          </div>
        )}
      />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          rowGap: '6px',
        }}
      >
        <div
          style={{
            display: 'flex',
            columnGap: '10px',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              rowGap: '4px',
            }}
          >
            <InputProjectSimulator
              form={form}
              name="hardFloor"
              defaultValue={buildingStructure.floor.hardFloor}
              rules={projectSimulatorFieldRules.percentage}
              isPercentageField={true}
              style={{ width: '67px' }}
            />
            <label className="form-field--label">
              {t(
                'APP.PROJECT.SIMULATOR.ADVANCED_CONCEPTION.FORM.FIELD.LABEL.HARD_FLOOR',
                {
                  defaultValue: 'Sol dur',
                }
              )}
            </label>
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              rowGap: '4px',
            }}
          >
            <InputProjectSimulator
              form={form}
              name="softFloor"
              defaultValue={buildingStructure.floor.softFloor}
              rules={projectSimulatorFieldRules.percentage}
              isPercentageField={true}
              style={{ width: '67px' }}
            />
            <label className="form-field--label">
              {t(
                'APP.PROJECT.SIMULATOR.ADVANCED_CONCEPTION.FORM.FIELD.LABEL.SOFT_FLOOR',
                {
                  defaultValue: 'Sol souple',
                }
              )}
            </label>
          </div>
        </div>
        <MaterialSynthese lines={floorMaterials} />
      </div>
    </div>
  );
}
export default BuildingStructureLastPart;
